// Mock data for Alma Leve Weddings

export const heroData = {
  title: "Alma Leve Weddings",
  subtitle: "Onde cada detalhe conta uma história de amor",
  tagline: "Planeamento de casamentos com alma, delicadeza e serenidade",
  ctaText: "Vamos planear o seu dia",
  backgroundImage: "https://images.pexels.com/photos/1128783/pexels-photo-1128783.jpeg"
};

export const aboutData = {
  title: "Sobre Mim",
  subtitle: "A pessoa por trás dos sonhos",
  image: "https://customer-assets.emergentagent.com/job_elegant-weddings-8/artifacts/6i5vy6js_file_000000006c40722fa7fab9d4d30b1781.png",
  paragraphs: [
    "Olá! Chamo-me Véronique de Sousa Rendeiro e sou a fundadora da Alma Leve Weddings e a minha missão é transformar o planeamento do vosso casamento numa experiência tranquila e memorável.",
    "Desde sempre que os casamentos me fascinam. A magia de ver duas pessoas a celebrarem o seu amor, rodeadas de quem mais amam, desperta em mim uma paixão genuína por criar momentos inesquecíveis. Cada casal é único e merece um dia que reflita verdadeiramente a sua história de amor.",
    "O meu compromisso é estar ao vosso lado em cada passo, cuidando de todos os detalhes para que possam viver este momento com leveza, alegria e sem preocupações. Porque o vosso amor merece ser celebrado com toda a atenção e carinho."
  ],
  values: [
    { title: "Serenidade", description: "Transformo a complexidade em calma" },
    { title: "Atenção ao Detalhe", description: "Cada pormenor é cuidado com amor" },
    { title: "Personalização", description: "O vosso casamento, à vossa imagem" }
  ]
};

export const servicesData = {
  title: "Serviços",
  subtitle: "Cada casamento merece um acompanhamento à sua medida",
  services: [
    {
      id: 1,
      title: "Essência",
      packType: "Pack Essencial",
      description: "Para casais que gostam de ter as rédeas do planeamento, mas valorizam a segurança de uma orientação profissional. Um ponto de partida sólido para começarem esta jornada com confiança.",
      icon: "MessageCircle",
      features: [
        { 
          title: "Consultoria inicial personalizada", 
          description: "Uma sessão dedicada a conhecer a vossa visão, responder a dúvidas e traçar o caminho do planeamento." 
        },
        { 
          title: "Orientação geral no planeamento", 
          description: "Linhas orientadoras sobre timings, prioridades e decisões fundamentais para o vosso casamento." 
        },
        { 
          title: "Apoio na organização base", 
          description: "Ferramentas e estrutura para manterem tudo organizado ao longo do processo." 
        },
        { 
          title: "Lista de fornecedores recomendados", 
          description: "Acesso a contactos de confiança adequados ao vosso estilo e orçamento." 
        }
      ],
      ideal: "Ideal para casais autónomos que querem planear ao seu ritmo, mas com a tranquilidade de saber que têm apoio profissional quando precisarem."
    },
    {
      id: 2,
      title: "Harmonia",
      packType: "Pack Intermédio",
      description: "Um acompanhamento mais próximo para casais que desejam partilhar o processo de planeamento. Estarei ao vosso lado nas decisões importantes, garantindo que cada escolha reflete quem são.",
      icon: "Clock",
      features: [
        { 
          title: "Planeamento estruturado e faseado", 
          description: "Organização completa do processo com etapas claras, prazos definidos e acompanhamento regular." 
        },
        { 
          title: "Apoio na seleção de fornecedores", 
          description: "Presença nas reuniões com fornecedores, análise de propostas e orientação nas escolhas." 
        },
        { 
          title: "Gestão de timings e prioridades", 
          description: "Acompanhamento ativo para garantir que nada fica esquecido e tudo acontece no momento certo." 
        },
        { 
          title: "Reuniões de acompanhamento periódicas", 
          description: "Pontos de situação regulares para ajustar detalhes e manter o planeamento no rumo certo." 
        },
        { 
          title: "Apoio próximo nas semanas finais", 
          description: "Presença mais intensa à medida que o grande dia se aproxima, para que cheguem tranquilos ao altar." 
        }
      ],
      ideal: "Ideal para casais que querem estar envolvidos no planeamento, mas preferem ter alguém de confiança a caminhar ao seu lado."
    },
    {
      id: 3,
      title: "Plenitude",
      packType: "Pack Completo",
      description: "A experiência integral de ter uma wedding planner dedicada ao vosso casamento. Do primeiro esboço ao último sorriso da noite, cuido de tudo para que vivam cada momento com o coração leve.",
      icon: "Calendar",
      features: [
        { 
          title: "Planeamento completo do casamento", 
          description: "Gestão integral de todos os elementos, desde a escolha do espaço até aos últimos detalhes de decoração." 
        },
        { 
          title: "Curadoria e coordenação de fornecedores", 
          description: "Seleção criteriosa, negociação e gestão de toda a equipa que fará parte do vosso dia." 
        },
        { 
          title: "Design e visão criativa", 
          description: "Desenvolvimento de um conceito único que traduza a vossa história em cada detalhe visual." 
        },
        { 
          title: "Gestão de orçamento detalhada", 
          description: "Controlo rigoroso de custos, negociação de valores e transparência total ao longo do processo." 
        },
        { 
          title: "Coordenação total do dia do casamento", 
          description: "Direção de toda a operação no dia, para que só tenham de se preocupar em ser felizes." 
        },
        { 
          title: "Acompanhamento personalizado e próximo", 
          description: "Disponibilidade contínua, comunicação fluida e uma relação de confiança genuína." 
        }
      ],
      ideal: "Ideal para casais que desejam viver o planeamento e o dia do casamento com tranquilidade absoluta, sabendo que cada detalhe está em boas mãos."
    }
  ]
};

export const portfolioData = {
  title: "Portfólio",
  subtitle: "Histórias de amor que ajudámos a contar",
  weddings: [
    {
      id: 1,
      couple: "Ana & Pedro",
      location: "Quinta do Torneiro, Sintra",
      date: "Junho 2024",
      image: "https://images.pexels.com/photos/1721944/pexels-photo-1721944.jpeg",
      description: "Um casamento romântico ao ar livre com tons de rosa e verde sálvia."
    },
    {
      id: 2,
      couple: "Mariana & João",
      location: "Palácio de Seteais, Sintra",
      date: "Setembro 2024",
      image: "https://images.unsplash.com/photo-1632316962873-47ee3d309f02?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwyfHx3ZWRkaW5nJTIwZGVjb3JhdGlvbnxlbnwwfHx8fDE3Njc1OTI0MjV8MA&ixlib=rb-4.1.0&q=85",
      description: "Elegância clássica num cenário de sonho."
    },
    {
      id: 3,
      couple: "Sofia & Miguel",
      location: "Praia da Comporta",
      date: "Julho 2024",
      image: "https://images.pexels.com/photos/169190/pexels-photo-169190.jpeg",
      description: "Celebração íntima à beira-mar com decoração minimalista."
    },
    {
      id: 4,
      couple: "Beatriz & Tiago",
      location: "Convento do Espinheiro, Évora",
      date: "Maio 2024",
      image: "https://images.unsplash.com/photo-1625038032515-308ab14d10b9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3MjQyMTd8MHwxfHNlYXJjaHwzfHx3ZWRkaW5nJTIwZGVjb3JhdGlvbnxlbnwwfHx8fDE3Njc1OTI0MjV8MA&ixlib=rb-4.1.0&q=85",
      description: "Um casamento de sonho num espaço histórico."
    },
    {
      id: 5,
      couple: "Carolina & André",
      location: "Douro Valley",
      date: "Outubro 2024",
      image: "https://images.pexels.com/photos/1045541/pexels-photo-1045541.jpeg",
      description: "Vinhas como cenário para um amor genuíno."
    },
    {
      id: 6,
      couple: "Inês & Ricardo",
      location: "Quinta da Pacheca, Douro",
      date: "Agosto 2024",
      image: "https://images.pexels.com/photos/931177/pexels-photo-931177.jpeg",
      description: "Tons naturais e flores silvestres."
    }
  ]
};

export const testimonialsData = {
  title: "Testemunhos",
  subtitle: "O que dizem os nossos casais",
  testimonials: [
    {
      id: 1,
      couple: "Ana & Pedro",
      text: "A Alma Leve transformou o que poderia ser um período stressante numa experiência verdadeiramente mágica. Cada detalhe foi cuidado com tanto carinho que só tivemos de aparecer e desfrutar do nosso dia.",
      image: "https://images.pexels.com/photos/35234733/pexels-photo-35234733.jpeg",
      rating: 5
    },
    {
      id: 2,
      couple: "Mariana & João",
      text: "Profissionalismo, dedicação e uma sensibilidade incrível. Recomendamos de olhos fechados a qualquer casal que queira viver o planeamento do casamento com tranquilidade.",
      image: "https://images.pexels.com/photos/35234605/pexels-photo-35234605.jpeg",
      rating: 5
    },
    {
      id: 3,
      couple: "Sofia & Miguel",
      text: "Desde o primeiro contacto sentimos que estávamos em boas mãos. A atenção aos detalhes e o carinho com que tudo foi tratado superou todas as nossas expectativas.",
      image: "https://images.pexels.com/photos/313702/pexels-photo-313702.jpeg",
      rating: 5
    }
  ]
};

export const blogData = {
  title: "Blog",
  subtitle: "Inspiração e dicas para o vosso dia",
  posts: [
    {
      id: 1,
      title: "10 Dicas para Escolher o Local Perfeito",
      excerpt: "O local do casamento define o tom de toda a celebração. Descubra como encontrar o espaço ideal para o vosso dia especial.",
      image: "https://images.pexels.com/photos/1128783/pexels-photo-1128783.jpeg",
      date: "15 Janeiro 2025",
      category: "Planeamento",
      readTime: "5 min"
    },
    {
      id: 2,
      title: "Tendências de Decoração para 2025",
      excerpt: "Dos tons naturais às flores secas, explore as tendências que vão marcar os casamentos este ano.",
      image: "https://images.pexels.com/photos/931177/pexels-photo-931177.jpeg",
      date: "8 Janeiro 2025",
      category: "Decoração",
      readTime: "4 min"
    },
    {
      id: 3,
      title: "Como Gerir o Stress do Planeamento",
      excerpt: "Estratégias práticas para manter a calma e desfrutar de cada momento até ao grande dia.",
      image: "https://images.pexels.com/photos/540522/pexels-photo-540522.jpeg",
      date: "2 Janeiro 2025",
      category: "Bem-estar",
      readTime: "6 min"
    }
  ]
};

export const contactData = {
  title: "Contacto",
  subtitle: "Vamos começar a planear o vosso dia",
  description: "Estou aqui para vos ouvir e perceber como posso ajudar a tornar o vosso casamento num dia inesquecível. Cada história é única e merece toda a atenção.",
  email: "info@almaleveweddings.com",
  phone: "+351 936 447 633",
  location: "Lisboa, Portugal",
  availability: "Disponível para casamentos em todo o país e destinos internacionais"
};

export const socialLinks = {
  instagram: "https://www.instagram.com/almaleve_weddings/",
  pinterest: "#",
  facebook: "https://www.facebook.com/profile.php?id=61586161143944"
};

export const navigationLinks = [
  { name: "Início", href: "#home" },
  { name: "Sobre", href: "#about" },
  { name: "Serviços", href: "#services" },
  { name: "Celebrante", href: "/celebrante", isPage: true },
  { name: "Simulador", href: "/simulador", isPage: true },
  { name: "Ferramentas", href: "/ferramentas", isPage: true },
  { name: "Portfólio", href: "#portfolio" },
  { name: "Testemunhos", href: "#testimonials" },
  { name: "Contacto", href: "#contact" }
];
